__turbopack_context__.v({
  "aspect": "BlockHeroSplit-module-scss-module__wI6I5q__aspect",
  "aspectInner": "BlockHeroSplit-module-scss-module__wI6I5q__aspectInner",
  "column": "BlockHeroSplit-module-scss-module__wI6I5q__column",
  "ctaWrapper": "BlockHeroSplit-module-scss-module__wI6I5q__ctaWrapper",
  "description": "BlockHeroSplit-module-scss-module__wI6I5q__description",
  "hasDescription": "BlockHeroSplit-module-scss-module__wI6I5q__hasDescription",
  "hasInfluencerImage": "BlockHeroSplit-module-scss-module__wI6I5q__hasInfluencerImage",
  "icon": "BlockHeroSplit-module-scss-module__wI6I5q__icon",
  "iconPlacement": "BlockHeroSplit-module-scss-module__wI6I5q__iconPlacement",
  "image": "BlockHeroSplit-module-scss-module__wI6I5q__image",
  "imageOnLeft": "BlockHeroSplit-module-scss-module__wI6I5q__imageOnLeft",
  "influencerImage": "BlockHeroSplit-module-scss-module__wI6I5q__influencerImage",
  "inner": "BlockHeroSplit-module-scss-module__wI6I5q__inner",
  "root": "BlockHeroSplit-module-scss-module__wI6I5q__root",
  "svgLockup": "BlockHeroSplit-module-scss-module__wI6I5q__svgLockup",
});
